import React, { FC } from "react";
import { Form, Input, DatePicker, Row, Col } from "antd";

interface BillDetailsProps {
  isEditable: boolean;
  caseClaimSubmissionId: number | null;
}

const BillDetails: FC<BillDetailsProps> = ({
  isEditable,
  caseClaimSubmissionId,
}) => {
  return (
    <>
      <h3>Bill Details</h3>
      <Row gutter={[16, 16]}>
        {/* <Col span={6}>
          <Form.Item
            name="otherHospitalExpenses"
            label="Other Hospital Expenses"
            rules={[
              {
                pattern: /^\d+$/,
                message: "Only Numeric values are allowed!",
              },
            ]}
          >
            <Input disabled={!isEditable} />
          </Form.Item>
        </Col> */}
        <Col span={6}>
          <Form.Item
            name="billDate"
            label="Bill Date"
            rules={[{ required: true, message: "Required" }]}
          >
            <DatePicker
              format="DD-MM-YYYY HH:mm:ss"
              disabled={!isEditable}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        {/* <Col span={6}>
          <Form.Item name="billAmount" 
          label="Bill Amount" 
          rules={[
              {
                pattern: /^\d+$/,
                message: "Only Numeric values are allowed!",
              },
            ]}>
            <Input disabled={!isEditable} />
          </Form.Item>
        </Col> */}
        <Col span={6}>
          <Form.Item
            name="billNumber"
            label="Bill Number"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input disabled={!isEditable} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default BillDetails;
